export default {
  primary: '#867968',
  secondary: '#fffae6',
  tertiary: '#ba9461',
  accent: '#49dbc6',
  background: '#fff3c5',
}